<template>
  <div style="height: 100%;width: 100%;display: flex;flex-direction: row">
    <PdfView class="parent" v-if="showPdf" @iframe-click="handleIframeClick" :url="fileObj.url" style="width:100%;height: 100%"></PdfView>
    <div v-else-if="showExcel" style="width: 100%;height: 99%;overflow:hidden">
      <vue-office-excel
          :src="fileObj.url"
          style="width: 100%; height: 100%"
      />
    </div>
    <div v-else-if="showDocx" style="width: 100%;height: 99%;overflow:hidden">
      <vue-office-docx :src=fileObj.url style="width: 100%; height: 100%"/>
    </div>
    <div v-else-if="showPng" style="width: 100%;height: 99%;overflow:hidden">
      <img id="img" :style="{transform:'scale('+multiples+')'}" :src=fileObj.url @mousedown.prevent="dropImage" @mouseup.prevent="loosen" @mousewheel.prevent='gunlun'/>
    </div>
    <div v-else style="width:63%;height: 100%">
      <el-empty description="抱歉，只支持pdf，xlsx，docx后缀文件以及图片预览，其余文件请自行下载查看"></el-empty>
    </div>
    <el-watermark :gap="[200,200]" :font="font" :content="this.userName" style="position:unset;">
    </el-watermark>
  </div>
</template>

<script>
import PdfView from "../project/PdfView.vue";

import VueOfficeExcel from "@vue-office/excel";
import "@vue-office/excel/lib/index.css";
import VueOfficeDocx from "@vue-office/docx";
import "@vue-office/docx/lib/index.css";

export default {
  name: "ViewPdf",
  inject: ['$fn'],
  components:{PdfView,VueOfficeExcel,VueOfficeDocx},
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      font: {
        fontSize: 30,
        color: 'rgba(0, 0, 0, 0.15)',
      },
      formData: {},
      dialogFormVisible: false,
      showPdf: false,
      showWord: false,
      showPng: false,
      showDocx:false,
      showExcel:false,
      fileObj: {},
      watermark:'',
      currentSub: 0,
      multiples: 1,
      odiv: null,
      listData:{},
      originalData:{},
      fileId:"",
      // is_hide: true,
      collapse: false,
      userName: '',
      stampType:"",
      x_coordinate:"",
      y_coordinate:"",
      loading: false,
      containerId: new Date().getTime(),
    }
  },
  computed: {
    stampTypeList() {
      return this.$store.getters['core/getDictList']("doc_stamp_type");
    },
  },
  async created() {
    // this.getCurrentUserName()
    this.listData = this.parentData
    console.log("this.parentData-=",this.parentData)
    let file = this.parentData;

    // await this.$http('prjWorkRecordService.getFileById', {file_id: file.id}).then(data => {
    //   if (data.ver_list[0].sys_file.file_suffix.match("pdf")){
    //     this.showPdf = true
    //   }
    //   if (data.ver_list[0].sys_file.file_suffix.match(".xlsx")){
    //     this.showExcel = true
    //   }
    //   if (data.ver_list[0].sys_file.file_suffix.match(".jpg") || data.ver_list[0].sys_file.file_suffix.match(".png") || data.ver_list[0].sys_file.file_suffix.match(".jpeg")){
    //     this.showPng = true
    //   }
    if (file.file_suffix.match(".pdf")){
          this.showPdf = true
    }
    if (file.file_suffix.match(".xlsx") || file.file_suffix.match(".xls")){
          this.showExcel = true
    }
    if (file.file_suffix.match(".jpg") || file.file_suffix.match(".png") || file.file_suffix.match(".jpeg")){
          this.showPng = true
    }
    if (file.file_suffix.match(".docx")){
          this.showDocx = true
    }
    this.fileObj = file
    console.log("fileObj-=",file)
    this.fileId = file.id

  },

  methods:{

    onIframeLoad(event) {
      const iframe = event.target;
      iframe.contentDocument.addEventListener('click', this.handleClick);
    },

    handleIframeClick(coordinates) {
      this.x_coordinate = Math.round(coordinates.x);
      this.y_coordinate = Math.round(coordinates.y)
      console.log(`Clicked at (${coordinates.x}, ${coordinates.y})`);
    },

    downloadFile(appendix) {
      let url = appendix?.sys_file?.url;
      if (!url) {
        return
      }
      let name = appendix.ver_name

      const a = document.createElement('a')

      if (!url.startsWith('http')) {
        url = window.location.protocol + "//" + window.location.host + (url.startsWith('/') ? '' : '/') + url;
      }
      // 这里是将url转成blob地址，
      fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
        a.href = URL.createObjectURL(blob)
        a.download = name || '' // 下载文件的名字
        document.body.appendChild(a)
        a.click()

        //在资源下载完成后 清除 占用的缓存资源
        window.URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      })
    },

    prevPage(){
      if (this.currentSub-1 <0){
        this.$message.error("当前已经是最新版本了。")
      }else {
        this.currentSub--
      }
    },



    gunlun(e) {
      let direction = e.deltaY > 0 ? 'down' : 'up'
      if (direction === 'up') {
        if (this.multiples >= 10) {
          return;
        }
        this.multiples += 0.25;
        // 滑轮向上滚动
      } else {
        if (this.multiples <= 0.5) {
          return;
        }
        this.multiples -= 0.25;
        // 滑轮向下滚动
      }
    },
    dropImage(e) {
      if (e === null) {
        return
      }
      this.odiv = e.target;        //获取目标元素
      //算出鼠标相对元素的位置
      let disX = e.clientX - this.odiv.offsetLeft;
      let disY = e.clientY - this.odiv.offsetTop;
      document.onmousemove = (e) => {       //鼠标按下并移动的事件
        //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        let left = e.clientX - disX;
        let top = e.clientY - disY;

        //绑定元素位置到positionX和positionY上面
        this.positionX = top;
        this.positionY = left;

        //移动当前元素
        this.odiv.style.left = left + 'px';
        this.odiv.style.top = top + 'px';
      }
    },

    loosen(){
      document.onmousemove = null;
      document.onmouseup = null;
    }
  },

}
</script>

<style scoped>
.titleText{
  font-size: 30px;
  width: 100%;
  text-align: center;
}
img {
  height: 100%;
  width: auto;
  position: relative;
}
.iconArrow{
  width: 60px;
  height: 55px;
  font-size: 30px;
}
.leftButton{
  position: absolute;
  top: 45%;
  left: 2%;
  margin: auto;
}
.rightButton{
  position: absolute;
  top: 45%;
  right: 37%;
  margin: auto;
}

.arrow {
  width: 6px;
  height: 40px;
  position: absolute;
  color: white;
  background-color: #409eff;
  border-radius: 3px;
  top: 40%;
  margin-left: -5px;
  opacity: 0.2;
  z-index: 999;
  transition: width 0.7s, opacity 0.7s;
  cursor: pointer;
}

.arrowUp {
  width: 10px;
  height: 40px;
  position: absolute;
  color: white;
  background-color: green;
  border-radius: 3px;
  top: 30%;
  margin-left: -5px;
  opacity: 0.2;
  z-index: 999;
  transition: width 0.7s, opacity 0.7s;
  cursor: pointer;
}


.arrowDown {
  width: 10px;
  height: 40px;
  position: absolute;
  color: white;
  background-color: green;
  border-radius: 3px;
  top: 50%;
  margin-left: -5px;
  opacity: 0.2;
  z-index: 999;
  transition: width 0.7s, opacity 0.7s;
  cursor: pointer;
}

.arrow:hover {
  opacity: 0.8;
  width: 18px;
}

.arrowUp:hover {
  opacity: 0.8;
  width: 18px;
}

.arrowDown:hover {
  opacity: 0.8;
  width: 18px;
}


.parent {
  position: relative; /* 父元素设置为相对定位 */
  width: 300px;
  height: 300px;
  border: 1px solid black;
}

.child {
  position: absolute; /* 子元素设置为绝对定位 */
  top: 100px; /* 调整子元素的位置 */
  left: 100px;
  width: 100px;
  height: 100px;
}
</style>
